import React, { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getModalSwitch, handleGetProfileData } from '@app/store/actions';
import { useTypedTranslation } from '@app/hooks';
import { ModalActionsComponent } from '@app/components';
import { onPressEnterModal } from '@app/helpers';
import {
    getIsDisabledManageMfa,
    handleClickPrimaryManageMfa,
    handleClickSecondaryManageMfa,
    getSecondaryBtnNameManageMfa,
    getPrimaryBtnNameManageMfa
} from '@app/helpers';
import { ManageMfa } from '@app/modules/mfaToken/components';
import { IManageMfaToken } from '@app/models';

export const ManageMfaTokenDialog: React.SFC<IManageMfaToken> = ({
    activeMethod,
    setActiveMethod,
    isMfaConfigured,
    stepManageMfa,
    setStepManageMfa,
    setIsModalActive
}) => {
    const sourceCancel = axios.CancelToken.source();

    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState<string>('');
    const [passCode, setPassCode] = useState<string>('');
    const [isDisableButtonNext, setIsDisableButtonNext] = useState<boolean>(true);

    const setCompleted = () => {
        dispatch(getModalSwitch(false));
    };

    const onSubmitForm = () =>
        handleClickPrimaryManageMfa({
            setIsWaitResponse: () => {},
            setStepManageMfa,
            stepManageMfa,
            passCode,
            verifyErrorCb: () => {
                setErrorMessage(translation('MFA_FAILED_VALIDATION'));
            },
            completeCb: () => {
                dispatch(getModalSwitch(false));
                dispatch(handleGetProfileData());
            }
        });

    return (
        <>
            <form
                tabIndex={0}
                className='modal__form'
                onKeyPress={onPressEnterModal(onSubmitForm(), getIsDisabledManageMfa(stepManageMfa, activeMethod, isDisableButtonNext, passCode))}
            >
                <div className='manage-mfa-token__modal'>
                    <div className='modal__dialog--content manage-mfa-token'>
                        <ManageMfa
                            isMfaConfigured={isMfaConfigured}
                            activeMethod={activeMethod}
                            setActiveMethod={setActiveMethod}
                            sourceCancel={sourceCancel}
                            isDisableButtonNext={isDisableButtonNext}
                            setIsDisableButtonNext={setIsDisableButtonNext}
                            setStepManageMfa={setStepManageMfa}
                            setErrorMessage={setErrorMessage}
                            setPassCode={setPassCode}
                            errorMessage={errorMessage}
                            stepManageMfa={stepManageMfa}
                            passCode={passCode}
                            setCompleted={setCompleted}
                        />
                        {errorMessage && <div className='modal__error'>{errorMessage}</div>}
                    </div>
                </div>
            </form>
            <ModalActionsComponent
                primaryBtn={getPrimaryBtnNameManageMfa(activeMethod, stepManageMfa, translation)}
                disabled={getIsDisabledManageMfa(stepManageMfa, activeMethod, isDisableButtonNext, passCode)}
                secondaryBtn={getSecondaryBtnNameManageMfa(stepManageMfa, translation)}
                onClickPrimary={onSubmitForm()}
                onClickSecondary={handleClickSecondaryManageMfa(sourceCancel, setStepManageMfa, dispatch, setIsModalActive)}
                id='changePhone'
            />
        </>
    );
};
